import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {productionStepQueryKeys} from '../production-step-query-keys';

interface Props {
  productionStepId: number;
  variationId: number;
}

export function useProductionStepMaterialDeleteMutation(
  props: Props,
): { mutate: () => void, isPending: boolean } {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () =>
      AxiosHttpClient.delete(
        `${environment.apiv4uri}article/config/production/step/${
          props.productionStepId
        }/material/condition/${props.variationId}`),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: productionStepQueryKeys.materialConditionsList(props.productionStepId),
      });
    },
  });
  return {mutate: () => mutation.mutate(), isPending: mutation.isPending};
}
